import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tp0012',
    ecrans: ['00-2']
});
